import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

/**
 * Header Novos Negocios Lista.
 * 
 */

type StatusOption = {
  id: number;
  title: string;
};

type Props = {
  ddlCliente: DropDown[];
  selectedIdsCliente?: number[];
  cidade?: string | null;
  status?: number;
  data?: Date | null;

  onClearFilters: () => void;
  handleIdsClienteChange: (v: number[]) => void;
  handleCidadeChange: (novaCidade: string | null) => void;
  handleStatusChange: (novoStatus: number | null) => void;
  handleDataChange: (novaData: Date | null) => void;
};

export const Header = ({
  ddlCliente,
  selectedIdsCliente,
  cidade,
  status,
  data,
  onClearFilters,
  handleIdsClienteChange,
  handleCidadeChange,
  handleStatusChange,
  handleDataChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();

  }, [onClearFilters]);

  const statusOptions: StatusOption[] = [
    { id: 4, title: 'Todas' },
    { id: 0, title: 'Em análise' },
    { id: 2, title: 'Descartar' },
    { id: 8, title: 'Processo concluído com sucesso' },
    { id: 1, title: 'Participar da licitação - Todas' },
    { id: 3, title: 'Participar da licitação - Ganha' },
    { id: 5, title: 'Participar da licitação - Perdida' },
    { id: 6, title: 'Participar da licitação - Inabilitada' },
    { id: 7, title: 'Participar da licitação - Outros' },
  ];

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-2 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-3 lg:col-span-3 gap-1 " >

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Cliente'
                  value={ddlCliente.filter(x => selectedIdsCliente?.includes(x.id))}
                  options={ddlCliente}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsClienteChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='cidade'
                  label='Cidade'
                  value={cidade}
                  onChangeValue={handleCidadeChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultDatePickerInput
                  label="Data"
                  value={data}
                  onChange={handleDataChange}
                />

              </div>

              <div className="w-full">
                <DefaultAutocomplete
                  label='Status'
                  value={statusOptions.find(x => x.id === status) ?? null}
                  options={statusOptions}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleStatusChange(x ? x.id : 4)} />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:grid-cols-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}